import { createContext } from "react";
import type Uppy from "@uppy/core";

interface UppyContextValue {
  uppy: Uppy;
}

export const UppyContext = createContext<UppyContextValue | null>(null);

